"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiSelectableListItem = _interopRequireDefault(require("./HiSelectableListItem"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles() {
  return {
    root: {}
  };
};

/**
 * Construit une liste d'item sélectionnable (avec checkbox)
 */
var HiSelectableListHierarchic = /*#__PURE__*/function (_React$PureComponent) {
  function HiSelectableListHierarchic() {
    var _this;
    (0, _classCallCheck2.default)(this, HiSelectableListHierarchic);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HiSelectableListHierarchic, [].concat(args));
    _this.handleSelect = function (item) {
      return function (event) {
        _this.props.onSelect(event, item);
      };
    };
    /**
     * Build list item and children items
     *
     * @param item
     * @param level
     * @returns {*}
     */
    _this.buildRecursiveListItem = function (item) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _this$props = _this.props,
        checkedIcon = _this$props.checkedIcon,
        disabled = _this$props.disabled,
        disabledItemIdList = _this$props.disabledItemIdList,
        hideCheckbox = _this$props.hideCheckbox,
        hoverIcon = _this$props.hoverIcon,
        icon = _this$props.icon,
        selectedItemIdList = _this$props.selectedItemIdList,
        others = (0, _objectWithoutProperties2.default)(_this$props, ["checkedIcon", "disabled", "disabledItemIdList", "hideCheckbox", "hoverIcon", "icon", "selectedItemIdList"]);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_HiSelectableListItem.default, (0, _extends2.default)({}, others, {
        checkedIcon: checkedIcon,
        disabled: disabled || disabledItemIdList.includes(item.id),
        hideCheckbox: hideCheckbox,
        hoverIcon: hoverIcon,
        icon: icon,
        key: item.id,
        level: level,
        onSelect: _this.handleSelect(item),
        selected: selectedItemIdList.includes(item.id)
        // item props override upper props (disabled, hideCheckbox, icon, level...)
      }, item)), item.children && item.children.length > 0 && item.children.filter(function (subItem) {
        return !subItem.displayed;
      }).map(function (subItem) {
        return _this.buildRecursiveListItem(subItem, level + 1);
      }));
    };
    return _this;
  }
  (0, _inherits2.default)(HiSelectableListHierarchic, _React$PureComponent);
  return (0, _createClass2.default)(HiSelectableListHierarchic, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        itemList = _this$props2.itemList,
        onKeyDown = _this$props2.onKeyDown,
        checkedIcon = _this$props2.checkedIcon,
        disabled = _this$props2.disabled,
        disabledItemIdList = _this$props2.disabledItemIdList,
        hideCheckbox = _this$props2.hideCheckbox,
        hoverIcon = _this$props2.hoverIcon,
        icon = _this$props2.icon,
        selectedItemIdList = _this$props2.selectedItemIdList,
        others = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "itemList", "onKeyDown", "checkedIcon", "disabled", "disabledItemIdList", "hideCheckbox", "hoverIcon", "icon", "selectedItemIdList"]);
      var parents = [];
      return /*#__PURE__*/_react.default.createElement(_List.default, {
        className: classes.root,
        onKeyDown: onKeyDown
      }, itemList.filter(function (item) {
        return !item.displayed;
      }).map(function (item) {
        // On stocke l'id des parents dans un tableau
        if (item.parentId && !parents.includes(item.parentId)) {
          parents.push(item.parentId);
        } else if (item.parentId && parents.includes(item.parentId)) {
          // Si l'item n'a pas de parentId ou qu'on l'a déjà stocké :
          // Et si le parentId n'est pas le dernier inseré
          if (item.parentId !== parents[parents.length - 1]) {
            // On est donc redescendu d'un niveau
            // donc on supprime le dernier parent
            parents.pop();
          }
        } else if (!item.parentId && parents.length > 0) {
          // Si l'item n'a pas de parent et que le tableau des parent
          // n'est pas vide => on le réinitialise
          parents = [];
        }
        return /*#__PURE__*/_react.default.createElement(_HiSelectableListItem.default, (0, _extends2.default)({}, others, {
          checkedIcon: checkedIcon,
          disabled: disabled || disabledItemIdList.includes(item.id),
          hideCheckbox: hideCheckbox,
          hoverIcon: hoverIcon,
          icon: icon,
          key: item.id,
          level: parents.length,
          onSelect: _this2.handleSelect(item),
          selected: selectedItemIdList.includes(item.id)
          // item props override upper props (disabled, hideCheckbox, icon, level...)
        }, item));
      }));
    }
  }]);
}(_react.default.PureComponent);
HiSelectableListHierarchic.defaultProps = {
  allSelected: false,
  disabled: false,
  disabledItemIdList: [],
  hideCheckbox: false,
  selectedItemIdList: []
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiSelectableListHierarchic'
})(HiSelectableListHierarchic);